import { useSelector } from "react-redux";
import { isLoggedIn } from "../../actions/global";
import isEmpty from "lodash/isEmpty";
import Chat from "./Chat";
import ChatBtnConsult from "./ChatBtnConsult";

function ChatBtnsGroup({ chat }) {
  const { session } = useSelector((state) => state.users);

  const loggedIn = isLoggedIn();

  return chat && loggedIn && !isEmpty(session) ? (
    <Chat user={session} />
  ) : (
    <div className="chat">
      <div className="chat__buttons chat__buttons_single">
        <ChatBtnConsult isShowButtons={true} />
      </div>
    </div>
  );
}

export default ChatBtnsGroup;
